import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { TextView } from 'src/core/ui/text.view';
import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';

interface AirlineFormViewProps extends ComponentViewProps<AirlineItem> {
	title: string,
	save: () => void,
	cancel: () => void,
	model: AirlineItem;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
}

@observer
export class AirlineFormView extends React.Component<AirlineFormViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 6, span: 12 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChanged}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						{
							model != null &&
							<CardController
								mode={this.props.mode}
								icon="book"
								title="General information">
								<Row gutter={16}>
									<Col xs={24}>
										<TextView
											mode={this.props.mode}
											required
											label="Title"
											value={model.title}
											onGetErrorMessage={() => this.props.model.validate(false, 'title')}
											onChanged={newVal => model.title = newVal}
										/>
									</Col>
									<Col xs={24} lg={8}>
										<TextView
											mode={this.props.mode}
											required
											label="Iata Code"
											value={model.iataCode}
											onGetErrorMessage={() => this.props.model.validate(false, 'iataCode')}
											onChanged={newVal => model.iataCode = newVal}
										/>
									</Col>
									<Col xs={24} lg={8}>
										<TextView
											mode={this.props.mode}
											required
											label="Icao Code"
											value={model.icaoCode}
											onGetErrorMessage={() => this.props.model.validate(false, 'icaoCode')}
											onChanged={newVal => model.icaoCode = newVal}
										/>
									</Col>
									<Col xs={24} lg={8}>
										<TextView
											mode={this.props.mode}
											required
											label="Iso Code"
											value={model.iso3Code}
											onGetErrorMessage={() => this.props.model.validate(false, 'iso3Code')}
											onChanged={newVal => model.iso3Code = newVal}
										/>
									</Col>
									<Col xs={24}>
										<RegionEditorController
											label="Region"
											mode={this.props.mode}
											onChanged={(value) => { model.regionId = value != null ? value.id : null }}
											value={model.regionId}
											setBusy={this.props.setBusy}
										/>
									</Col>
								</Row>
							</CardController>
						}
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/airlines/form/airline-form.view.tsx